import { Component, OnInit } from '@angular/core';
import { IOffre } from '../../../../models/offre.model';
import { IOffreCritere } from '../../../../models/offre-critere.model';
import { OffreService } from 'src/app/services/offre.service';
import { OffreCritereService } from 'src/app/services/offre-critere.service';
import { IValeurCritere } from 'src/app/models/valeur-critere.model';

interface IOFFRE {
  offre: IOffre;
  criteres: IValeurCritere[]
};

@Component({
  selector: 'app-homethirteen-courses',
  templateUrl: './homethirteen-courses.component.html',
  styleUrls: ['./homethirteen-courses.component.scss']
})
export class HomethirteenCoursesComponent implements OnInit {
  offres: IOFFRE[] = [];

  constructor(
    private offreService: OffreService,
    private offreCritereService: OffreCritereService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  async init() : Promise<void> {
    this.offres = [];

    const responseOffre = await this.offreService.getAll().toPromise();

    for await (const iterator of responseOffre.objects) {
      const responseOffreCritere = await this.offreCritereService.getByOffre(iterator.id).toPromise();
      let valeursCritere: IValeurCritere[] = [];
      for await (const valeur of responseOffreCritere.objects) {
        valeursCritere.push(valeur.valeurCritereDTO);
      }
      const data: IOFFRE = {
        offre: iterator,
        criteres: valeursCritere
      };
      this.offres.push(data)
    }
    
    // responseOffre.objects.forEach(async offre => {
    //   const responseOffreCritere = await this.offreCritereService.getByOffre(offre.id).toPromise();
    //   const data: IOFFRE = {
    //     offre: offre,
    //     criteres: responseOffreCritere.objects
    //   };
    //   this.offres.push(data)
    // });

    console.log(this.offres);
    
  }

}
